import { render, staticRenderFns } from "./communication-note.vue?vue&type=template&id=50b3eb5d"
import script from "./communication-note.vue?vue&type=script&lang=js"
export * from "./communication-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports